import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ProfileLayer from "../components/ProfileLayer";

const ProfilePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Profile' />

        {/* BlogLayer */}
        <ProfileLayer />
      </MasterLayout>
    </>
  );
};

export default ProfilePage;